import './Events.css';

function Events() {
  return (
    <main className="events">
      <div className="events-inner">
        <header className="events-details">
          <h2 className="events-details-title">Details of the day</h2>
          <p className="events-details-subtitle">Everything you need to know!</p>
        </header>
        <div className="events-divider" aria-hidden="true">
          ✦
        </div>
        <div className="events-icon" aria-hidden="true">
          <svg viewBox="0 0 48 48" role="img" aria-hidden="true">
            <path
              d="M12 18h24v18H12z"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            />
            <path
              d="M16 14v8M32 14v8M12 22h24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h2 className="events-title">Events</h2>
        <p className="events-subtitle">We would love to see you on both the days!</p>
        <div className="events-grid">
          <article className="events-card">
            <div className="events-card-header">
              <span className="events-card-icon" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M5.8 11.3 2 22l10.7-3.79" />
                  <path d="M4 3h.01" />
                  <path d="M22 8h.01" />
                  <path d="M15 2h.01" />
                  <path d="M22 20h.01" />
                  <path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10" />
                  <path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17" />
                  <path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7" />
                  <path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z" />
                </svg>
              </span>
              <h3 className="events-card-title">Reception</h3>
            </div>
            <div className="events-card-details">
              <p>Saturday, 21 February, 2026</p>
              <p>6:30 pm Onwards</p>
            </div>
          </article>
          <article className="events-card">
            <div className="events-card-header">
              <span className="events-card-icon" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                </svg>
              </span>
              <h3 className="events-card-title">Wedding</h3>
            </div>
            <div className="events-card-details">
              <p>Sunday, 22 February 2026</p>
              <p>10:00 am to 11:15 am</p>
            </div>
          </article>
        </div>
      </div>
    </main>
  );
}

export default Events;
